




























































































































































































































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import fieldData, { CCDD } from "@/ts/FormData";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { ISelectItemVueModel } from "@/ts/models/ISelectItemVueModel";
import { ICCDDApplicationVueModel } from "@/ts/models/ICCDDApplicationVueModel";

@Component({
    props: {
        form: {
            type: Object as () => ICCDDApplicationVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class CCDDApplicationDailyOperations extends Vue {
    name: string = "CCDDApplicationDailyOperations";
    title: string = "";
    index: number = NaN;

    unitsOfMeasure = fieldData.unitsOfMeasure;
    errorMsgs = ErrorMessages;

    mounted(): void {
        this.initializeComponent("DailyOperations");
        this.initializeStaticData();
        this.initializeListeners();
    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[this.index].visited = true;
    }

    private initializeStaticData(): void {
        if (this.$props.form.acceptedSources.length === 0) {
            this.$props.form.acceptedSources = fieldData.acceptedSources;
        }
        
        if (this.$props.form.odorPreventionMethods.length === 0) {
            this.$props.form.odorPreventionMethods = fieldData.odorPreventionMethods;
        }

        if (this.$props.form.noisePreventionMethods.length === 0) {
            this.$props.form.noisePreventionMethods = fieldData.noisePreventionMethods;
        }

        if (this.$props.form.dustPreventionMethods.length === 0) {
            this.$props.form.dustPreventionMethods = fieldData.dustPreventionMethods;
        }

        if (this.$props.form.cleaningProcedures.length === 0) {
            this.$props.form.cleaningProcedures = fieldData.cleaningProcedures;
        }

        this.$props.form.isUnauthorizedMaterials = this.$props.form.isUnauthorizedMaterials == "" ? "" : this.$props.form.isUnauthorizedMaterials;
        this.$props.form.isReturnedMaterialsRecorded = this.$props.form.isReturnedMaterialsRecorded == "" ? "" : this.$props.form.isReturnedMaterialsRecorded;
        this.$props.form.isAcceptanceLogMaintained = this.$props.form.isAcceptanceLogMaintained == "" ? "" : this.$props.form.isAcceptanceLogMaintained;
        this.$props.form.isDocumentsUnauthorizedWaste = this.$props.form.isDocumentsUnauthorizedWaste == "" ? "" : this.$props.form.isDocumentsUnauthorizedWaste;
        this.$props.form.isRecordsIncomingTickets = this.$props.form.isRecordsIncomingTickets == "" ? "" : this.$props.form.isRecordsIncomingTickets;
        this.$props.form.isKeepsCalibrationLogs = this.$props.form.isKeepsCalibrationLogs == "" ? "" : this.$props.form.isKeepsCalibrationLogs;
        this.$props.form.isKeepsLoadInspectionLog = this.$props.form.isKeepsLoadInspectionLog == "" ? "" : this.$props.form.isKeepsLoadInspectionLog;
        this.$props.form.isKeepsRejectedLoadLog = this.$props.form.isKeepsRejectedLoadLog == "" ? "" : this.$props.form.isKeepsRejectedLoadLog;
        this.$props.form.isKeepsStreetSweaperWaterTruckLog = this.$props.form.isKeepsStreetSweaperWaterTruckLog == "" ? "" : this.$props.form.isKeepsStreetSweaperWaterTruckLog;
    }

    private initializeListeners(): void {
        this.$watch("isOtherSourcesSelected", (n, o) => {
            if (!n) {
                this.$props.form.acceptedSourceDescription = null;
            }
        }, { immediate: true });
        
        this.$watch("isOtherOdorPreventionSelected", (n, o) => {
            if (!n) {
                this.$props.form.odorPreventionDescription = null;
            }
        }, { immediate: true });

        this.$watch("isOtherNoisePreventionSelected", (n, o) => {
            if (!n) {
                this.$props.form.noisePreventionDescription = null;
            }
        }, { immediate: true });

        this.$watch("isOtherDustPreventionSelected", (n, o) => {
            if (!n) {
                this.$props.form.dustPreventionDescription = null;
            }
        }, { immediate: true });

        this.$watch("isOtherCleaningSelected", (n, o) => {
            if (!n) {
                this.$props.form.cleaningProcedureDescription = null;
            }
        }, { immediate: true });
    }

    get isOtherSourcesSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.acceptedSources);
    }
    
    get isOtherOdorPreventionSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.odorPreventionMethods);
    }

    get isOtherNoisePreventionSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.noisePreventionMethods);
    }

    get isOtherDustPreventionSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.dustPreventionMethods);
    }

    get isOtherCleaningSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.cleaningProcedures);
    }


    get isMaterialCapacityError(): boolean {
        return func.isNullOrEmpty(this.$props.form.materialCapacity) || (this.$props.form.materialCapacity as number) * 1 <= 0;
    }

    get isOtherSourcesError(): boolean {
        return this.isOtherSourcesSelected && func.isNullOrEmpty(this.$props.form.acceptedSourceDescription);
    }
    
    get isOtherOdorPreventionError(): boolean {
        return this.isOtherOdorPreventionSelected && func.isNullOrEmpty(this.$props.form.odorPreventionDescription);
    }

    get isOtherNoisePreventionError(): boolean {
        return this.isOtherNoisePreventionSelected && func.isNullOrEmpty(this.$props.form.noisePreventionDescription);
    }

    get isOtherDustPreventionError(): boolean {
        return this.isOtherDustPreventionSelected && func.isNullOrEmpty(this.$props.form.dustPreventionDescription);
    }

    get isOtherCleaningError(): boolean {
        return this.isOtherCleaningSelected && func.isNullOrEmpty(this.$props.form.cleaningProcedureDescription);
    }

    get isRecordKeepingError(): boolean {
        return func.isNullOrEmpty(this.$props.form.recordKeepingDescription);
    }

    get isProceduresDescription(): boolean {
        return func.isNullOrEmpty(this.$props.form.proceduresDescription);
    }

    get isRadioError(): boolean {
        return func.isNullOrEmpty(this.$props.form.isReturnedMaterialsRecorded)
            || func.isNullOrEmpty(this.$props.form.isUnauthorizedMaterials)
            || func.isNullOrEmpty(this.$props.form.isAcceptanceLogMaintained)
            || func.isNullOrEmpty(this.$props.form.isDocumentsUnauthorizedWaste)
            || func.isNullOrEmpty(this.$props.form.isRecordsIncomingTickets)
            || func.isNullOrEmpty(this.$props.form.isKeepsCalibrationLogs)
            || func.isNullOrEmpty(this.$props.form.isKeepsLoadInspectionLog)
            || func.isNullOrEmpty(this.$props.form.isKeepsRejectedLoadLog)
            || func.isNullOrEmpty(this.$props.form.isKeepsStreetSweaperWaterTruckLog)
    }   

    get hasErrors(): boolean {
        return this.isMaterialCapacityError ||
            this.isOtherSourcesError ||
            this.isOtherOdorPreventionError ||
            this.isOtherNoisePreventionError ||
            this.isOtherDustPreventionError ||
            this.isOtherCleaningError ||
            this.isRecordKeepingError ||
            this.isRadioError;
    }

    private getIsOtherOptionSelected(data: ISelectItemVueModel[]): boolean {
        let item = data.find(value => value.name.endsWith("*"));
        if (item === undefined || item === null) return false;
        return item.isSelected;
    }

}
